import React from 'react';
type CircleLightProps = {
  /** "slow" runs the sweep at a more languid pace for larger circles. */
  speed?: 'default' | 'slow';
  className?: string;
};
/**
 * A subtle highlight that travels around the rim of a round element — like
 * light catching the edge of the closed TARTA lid. Decorative + aria-hidden.
 * Place inside a `relative rounded-full` container (it fills and rims it).
 */
export function CircleLight({
  speed = 'default',
  className = ''
}: CircleLightProps) {
  return <span aria-hidden className={`circle-light ${speed === 'slow' ? 'circle-light--slow' : ''} ${className}`} data-id="element-52" data-mp="5b73qteisl79" />;
}